import React, {useEffect} from 'react';

import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CardLoading from "../../ui/CardLoading";
import StarRating from "../../ui/StarRating";
import dayjs from "dayjs";
import ButtonWithLoading from "../../layout/ui/ButtonWithLoading";
import LineChartRating from "./LineChartRating";
import LineChartRatingCount from "./LineChartRatingCount";

export default function BusinessCompetitorCard({competitor = {}, onDelete = () => {}, ...props}) {
    const { t} = useTranslation();
    const [metricsTabVisible, setMetricsTabVisible] = React.useState('rating');
    const metrics = {
        rating: t('Rating'),
        userRatingCount: t('Total Reviews'),
    }
    const dataRatingRef = React.useRef({rating: []});
    const dataReviewsCountRef = React.useRef({reviewsTotal: []});


    useEffect(() => {
        fillMetrics();
    }, []);


    const fillMetrics = () => {
        if (!competitor?.metrics || !competitor?.metrics.length) return;

        competitor.metrics.forEach((metric) => {
            const rating = metric?.data?.rating ?? 0;
            const reviewsTotal = metric?.data?.userRatingCount ?? 0;
            let dateCreated = metric?.created_at ?? null;
            dateCreated = dayjs(dateCreated).isValid() ? dayjs(dateCreated).format('YYYY-MM-DD HH:mm:ss') : null;

            if (rating && dataRatingRef.current === null) {
                dataRatingRef.current = {
                    rating: [],
                };
            }
            if (reviewsTotal && dataReviewsCountRef.current === null) {
                dataReviewsCountRef.current = {
                    reviewsTotal: [],
                };
            }

            if (rating) {
                dataRatingRef.current.rating.push([dateCreated, rating]);
            }
            if (reviewsTotal) {
                dataReviewsCountRef.current.reviewsTotal.push([dateCreated, reviewsTotal]);
            }
        });
    }


    const onLocalDelete = (e) => {
        e.preventDefault();

        if (window.confirm(t('Are you sure you want to delete this competitor?'))) {
            onDelete(competitor.id);
        }
    }


    return (
        <div className={'card overflow-hidden rounded-2'+(props.loading ? ' loading' : '')}>
            <div className="card-body pt-3 p-4">
                <div className="d-flex align-items-start justify-content-stretch">
                    <div className="d-flex flex-column w-100">
                        <ButtonWithLoading
                            className="btn-circle btn-sm btn-outline-danger align-items-center justify-content-center position-absolute top-0 end-0 z-3 m-3"
                            noOriginalIconClassName={true}
                            iconClassName="ti ti-x fs-3"
                            label={false}
                            loading={false}
                            onClick={onLocalDelete}
                        />

                        <h6 className="fw-semibold fs-4 one-liner position-relative">
                            {/*<Link to={'/'+['businesses', competitor.business_id, 'competitors', competitor.id].join('/')} className="text-dark">{competitor?.name ?? 'No title'}</Link>*/}
                            <span className="text-dark">{competitor?.name ?? 'No title'}</span>
                        </h6>
                        <StarRating rating={competitor?.data?.rating ?? 0} />

                        <div className="d-flex align-items-center justify-content-between">
                            <div className="fs-2 mb-0 one-liner w-100 d-flex flex-column gap-2">
                                {competitor?.data?.formattedAddress ? (<div>
                                Address:
                                <span className="text-muted d-block">{competitor?.data?.formattedAddress}</span>
                                </div>) : null}

                                {competitor?.data?.websiteUri ? (<div>
                                Website:
                                <a href={competitor?.data?.websiteUri} target="_blank" className="d-block">{competitor?.data?.websiteUri}</a>
                                </div>) : (
                                competitor?.data?.website ? (<div>
                                Website:
                                <a href={competitor?.data?.website} target="_blank" className="d-block">{competitor?.data?.website}</a>
                                </div>) : null
                                )}

                                {competitor?.data?.phone ? (<div>
                                Phone:
                                <span className="text-muted d-block">{competitor?.data?.phone}</span>
                                </div>) : (
                                competitor?.data?.internationalPhoneNumber ? (<div>
                                Phone:
                                <span className="text-muted d-block">{competitor?.data?.internationalPhoneNumber}</span>
                                </div>) : null
                                )}
                            </div>
                        </div>

                        <div className="mt-4">
                            <ul className="d-flex flex-row gap-3">
                                <li>{t('Metrics')}:</li>
                                {Object.keys(metrics).map((key, index) => {
                                    let label = competitor?.data[key] ?? t('N/A');

                                    return metricsTabVisible === key ? (
                                        <li key={'metric-'+index}>{metrics[key]}: {competitor?.data[key] ?? t('N/A')}</li>
                                    ) : (
                                        <li key={'metric-'+index}><a href={'#'} onClick={(e) => {
                                            e.preventDefault();
                                            setMetricsTabVisible(key);
                                        }}>{metrics[key]}: {label}</a></li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="">
                            {metricsTabVisible === 'rating' ? (
                                <LineChartRating data={dataRatingRef.current} />
                            ) : null}
                            {metricsTabVisible === 'userRatingCount' ? (
                                <LineChartRatingCount data={dataReviewsCountRef.current} />
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="mt-3 text-end fs-2">
                    <i className="ti ti-refresh fs-3 me-2"></i> {dayjs(competitor?.synced_at).isValid() ? t('Last synced on {{date}}', {date: dayjs(competitor?.synced_at).format('MMM D, YYYY, HH:mm')}) : t('Not synced yet')}
                </div>
            </div>

            <CardLoading loading={props.loading} />
        </div>
    );
}
